import {
  BaseSchedulerHighlightValue,
  createSchedulerFiltersStore,
  createSchedulerHighlightStore,
} from '@lp/core/store/scheduler';

export const useCCSchedulerFiltersStore = createSchedulerFiltersStore();

type CCSchedulerHighlightValue = BaseSchedulerHighlightValue;

export const useCCSchedulerHighlightStore = createSchedulerHighlightStore<CCSchedulerHighlightValue>();
